// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3SM7A","bigColWidth":"Table_bigColWidth__1dH9T","biggerColWidth":"Table_biggerColWidth__3JJvK","row":"Table_row__UldAZ","col":"Table_col__2I0E8"};